import { Typography, styled } from '@mui/material';

const SectionDescription = styled(Typography)(({ theme }) => ({
  fontFamily: 'Lato, sans-serif',
  fontSize: '1rem',
  color: theme.palette.grey[600]
}));

export default SectionDescription;
